<template>
  <div v-if="!matrix" class="dl-qr-loading" :style="loadingStyle" aria-label="QR-Code lädt">
    <VibelaMark :size="28" :show-cleft="false" />
  </div>
  <svg
    v-else
    :width="size"
    :height="size"
    :viewBox="`0 0 ${count} ${count}`"
    shape-rendering="geometricPrecision"
    aria-label="QR-Code zum Download der Vibela-App"
    role="img"
  >
    <defs>
      <linearGradient :id="gradId" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#FF8B6B" />
        <stop offset="55%" stop-color="#E63973" />
        <stop offset="100%" stop-color="#6B2952" />
      </linearGradient>
    </defs>
    <template v-for="(row, y) in matrix">
      <rect
        v-for="(cell, x) in row"
        v-if="cell"
        :key="`${y}-${x}`"
        :x="x + 0.08"
        :y="y + 0.08"
        width="0.84"
        height="0.84"
        rx="0.2"
        :fill="`url(#${gradId})`"
      />
    </template>
    <rect
      :x="center - finderRadius - 0.4"
      :y="center - finderRadius - 0.4"
      :width="finderSize + 0.8"
      :height="finderSize + 0.8"
      rx="1"
      fill="#FAF5EF"
    />
    <g :transform="`translate(${center - finderRadius * 0.85}, ${center - finderRadius * 0.85}) scale(${finderSize * 0.85 / 200})`">
      <path
        :d="logoPath"
        :fill="`url(#${gradId})`"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>

<script>
import qrcode from '../vendor/qrcode';
import VibelaMark from './VibelaMark.vue';

const LOGO_PATH =
  'M 100,178 L 38,95 C 20,10 80,10 100,70 C 120,10 180,10 162,95 L 100,178 Z M 80,76 L 100,138 L 120,76 Z';

export default {
  name: 'StyledQRCode',
  components: { VibelaMark },
  props: {
    data: { type: String, required: true },
    size: { type: Number, default: 96 },
  },
  data() {
    return {
      matrix: null,
      count: 0,
      gradId: `qr-grad-${this._uid}`,
      logoPath: LOGO_PATH,
    };
  },
  computed: {
    center() {
      return (this.count - 1) / 2;
    },
    finderSize() {
      return Math.floor(this.count * 0.22);
    },
    finderRadius() {
      return this.finderSize / 2;
    },
    loadingStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        background: 'var(--cream)',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(value) {
        this.buildMatrix(value);
      },
    },
  },
  methods: {
    buildMatrix(data) {
      this.matrix = null;
      try {
        const qr = qrcode(0, 'H');
        qr.addData(data);
        qr.make();
        const count = qr.getModuleCount();
        const matrix = [];
        const n = (count - 1) / 2;
        const r = Math.floor(count * 0.22) / 2;
        for (let y = 0; y < count; y++) {
          const row = [];
          for (let x = 0; x < count; x++) {
            const dark = qr.isDark(y, x);
            const inFinder =
              Math.abs(y - n) <= r && Math.abs(x - n) <= r;
            row.push(dark && !inFinder);
          }
          matrix.push(row);
        }
        this.count = count;
        this.matrix = matrix;
      } catch (e) {
        console.warn('QR generation failed', e);
      }
    },
  },
};
</script>
